import { FormRepository } from "../domain/FormRepository";

export class FormRepositoryNetlifyForms implements FormRepository {
  send(formData: FormData): Promise<Response> {
    return fetch(`/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    });
  }
}
